import { useCountdown } from '../../hooks/useCountdown';

export interface CountdownTimerProps {
  /** Initial countdown length in seconds. */
  seconds: number;
  onExpire?: () => void;
  className?: string;
}

function formatMmSs(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

/** Live mm:ss countdown (e.g. "01:58" on the OTP screen). */
export function CountdownTimer({ seconds, onExpire, className = '' }: CountdownTimerProps) {
  const { remaining } = useCountdown(seconds, onExpire);

  return (
    <time
      aria-live="polite"
      className={`font-sans font-semibold text-navy tabular-nums ${className}`.trim()}
    >
      {formatMmSs(remaining)}
    </time>
  );
}
